import React from 'react';
import { useDate } from '@zapier/date/src/components/DateProvider';
import formatDateTime from '@zapier/date/src/utils/formatDateTime';
import formatTimeSpan from '@zapier/date/src/utils/formatTimeSpan';
import getClientTimeZone from '@zapier/date/src/utils/getClientTimeZone';
import type { Dateable, TimeSpanFormatter } from '@zapier/date/src/utils/types';

interface RelativeTimeProp {
  date: Dateable;
  formatter?: TimeSpanFormatter;
  hasSuffix?: boolean;
}

const RelativeTime = (props: RelativeTimeProp) => {
  const { date, formatter = formatTimeSpan, hasSuffix } = props;
  // Get timezone from AppProvider (if exists)
  const { timezone } = useDate();

  // fallback to client timezone then to UTC if that fails
  const clientTimezone = timezone || getClientTimeZone() || 'UTC';

  const formattedISODate = formatDateTime(date, 'iso', clientTimezone);

  return (
    <time dateTime={formattedISODate} title={formattedISODate}>
      {formatter(Date.now(), date, hasSuffix !== false)}
    </time>
  );
};

export default RelativeTime;
